import _ from 'underscore';

export const minuteToSaveMap = {
  ZERO: 0,
  FIFTEEN: 15,
  THIRTY: 30,
  FORTY_FIVE: 45,
};

export const minuteMap = {
  0: 'ZERO',
  15: 'FIFTEEN',
  30: 'THIRTY',
  45: 'FORTY_FIVE',
};

export const getDay = (day) => {
  switch (day) {
    case 'Alldays':
      return _TL_('All days');
    case 'Monday':
      return _TL_('Monday');
    case 'Tuesday':
      return _TL_('Tuesday');
    case 'Wednesday':
      return _TL_('Wednesday');
    case 'Thursday':
      return _TL_('Thursday');
    case 'Friday':
      return _TL_('Friday');
    case 'Saturday':
      return _TL_('Saturday');
    case 'Sunday':
      return _TL_('Sunday');
    case 'MondayToFriday':
      return _TL_('Monday - Friday');
    default:
      return _TL_('All days');
  }
};

export const getMin = (min) => {
  switch (min) {
    case 0:
      return '00';
    case 15:
      return '15';
    case 30:
      return '30';
    case 45:
      return '45';
    default:
      return '00';
  }
};

export const getTime = (hour, is12) => {
  switch (hour) {
    case 0:
      return is12 ? _TL_('12:{{min}} AM') : _TL_('00:{{min}}');
    case 1:
      return is12 ? _TL_('01:{{min}} AM') : _TL_('01:{{min}}');
    case 2:
      return is12 ? _TL_('02:{{min}} AM') : _TL_('02:{{min}}');
    case 3:
      return is12 ? _TL_('03:{{min}} AM') : _TL_('03:{{min}}');
    case 4:
      return is12 ? _TL_('04:{{min}} AM') : _TL_('04:{{min}}');
    case 5:
      return is12 ? _TL_('05:{{min}} AM') : _TL_('05:{{min}}');
    case 6:
      return is12 ? _TL_('06:{{min}} AM') : _TL_('06:{{min}}');
    case 7:
      return is12 ? _TL_('07:{{min}} AM') : _TL_('07:{{min}}');
    case 8:
      return is12 ? _TL_('08:{{min}} AM') : _TL_('08:{{min}}');
    case 9:
      return is12 ? _TL_('09:{{min}} AM') : _TL_('09:{{min}}');
    case 10:
      return is12 ? _TL_('10:{{min}} AM') : _TL_('10:{{min}}');
    case 11:
      return is12 ? _TL_('11:{{min}} AM') : _TL_('11:{{min}}');
    case 12:
      return is12 ? _TL_('12:{{min}} PM') : _TL_('12:{{min}}');
    case 13:
      return is12 ? _TL_('01:{{min}} PM') : _TL_('13:{{min}}');
    case 14:
      return is12 ? _TL_('02:{{min}} PM') : _TL_('14:{{min}}');
    case 15:
      return is12 ? _TL_('03:{{min}} PM') : _TL_('15:{{min}}');
    case 16:
      return is12 ? _TL_('04:{{min}} PM') : _TL_('16:{{min}}');
    case 17:
      return is12 ? _TL_('05:{{min}} PM') : _TL_('17:{{min}}');
    case 18:
      return is12 ? _TL_('06:{{min}} PM') : _TL_('18:{{min}}');
    case 19:
      return is12 ? _TL_('07:{{min}} PM') : _TL_('19:{{min}}');
    case 20:
      return is12 ? _TL_('08:{{min}} PM') : _TL_('20:{{min}}');
    case 21:
      return is12 ? _TL_('09:{{min}} PM') : _TL_('21:{{min}}');
    case 22:
      return is12 ? _TL_('10:{{min}} PM') : _TL_('22:{{min}}');
    case 23:
      return is12 ? _TL_('11:{{min}} PM') : _TL_('23:{{min}}');
    case 24:
      return is12 ? _TL_('12:{{min}} AM') : _TL_('24:{{min}}');
    default:
      return is12 ? _TL_('00:{{min}} AM') : _TL_('00:{{min}}');
  }
};


export const getDayTimeDetails = (i18n, dayTime, is12, hideBidAdjustment = false) => {
  const startHour = dayTime().StartHour();
  const endHour = dayTime().EndHour();
  const startMin = getMin(minuteToSaveMap[dayTime().StartMinute()]);
  const endMin = getMin(minuteToSaveMap[dayTime().EndMinute()]);
  const dateTimePart = `${i18n.getString(getDay(dayTime().Day()))} ${i18n.getString(_TL_('from {{from}} to {{to}}'), {
    from: i18n.getString(getTime(startHour, is12), { min: startMin }),
    to: i18n.getString(getTime(endHour, is12), { min: endMin }),
  })}`;

  if (hideBidAdjustment) {
    return dateTimePart;
  }
  return `${dateTimePart}: ${(_.isUndefined(dayTime().BidAdjustmentType()) || dayTime().BidAdjustmentType() > 0) ? i18n.getString(_TL_('Increase By')) : i18n.getString(_TL_('Decrease By'))}
  ${_.isUndefined(dayTime().BidAdjustmentAmount()) ? 0 : dayTime().BidAdjustmentAmount()}%`;
};

export const getAdScheduleDetails = (i18n, adScheduleView, hideBidAdjustment = false) => {
  if (adScheduleView) {
    const useCampaignSettings = adScheduleView.koModel.useCampaignSettings();
    const schedules = useCampaignSettings ? adScheduleView.koModel.campaignDayTimeRanges() : adScheduleView.koModel.dayTimeRanges();
    let details = '';
    const dateSettings = adScheduleView.getDateSettings();
    if (!_.isEmpty(dateSettings) && dateSettings.EndDate !== '1/1/3000') {
      details = i18n.getString(_TL_('Scheduled from {{from}} to {{to}}: '), { from: dateSettings.StartDate, to: dateSettings.EndDate });
    }

    const hideAdScheduleBidAdjustments = adScheduleView.koModel.hideAdScheduleBidAdjustments();
    if (!hideAdScheduleBidAdjustments) {
      const is12 = adScheduleView.koModel.timeDisplayType() === '12-hour';
      const len = schedules.length;
      schedules.forEach((schedule, index) => {
        details += getDayTimeDetails(i18n, schedule, is12, hideBidAdjustment);
        if (details && index < len - 1) {
          details += ', ';
        }
      });
    }
    const adScheduleUseSearcherTimeZone = adScheduleView.getAdScheduleUseSearcherTimeZone();
    if (adScheduleUseSearcherTimeZone) {
      details += ` ${i18n.getString(_TL_('In Ad viewer\'s time zone'))}`;
    } else {
      details += ` ${i18n.getString(_TL_('In Your account\'s time zone'))}`;
    }
    return details;
  }
  return '';
};
